/* global API_SERVER */
import axios from 'axios';

/**
 * Retrieves the video template video record
 * @param  {string} publicId  Id
 */
export const getVideoTemplateVideo = (publicId) =>
  axios.get(`${API_SERVER}/api/video-template-videos/${publicId}/`);
